import React from 'react';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import useEEActive from '../../../../hooks/useEEActive';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import { CardModel } from '../../../../lib/shared-models/card.model';
import { CardProps, THeadingTag } from '../../../../types/types';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import GridCard from './gridCard';

const GridCardWrapper = (props: CardProps & { cardHeadingTag: THeadingTag }): JSX.Element => {
  const model = new CardModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);
  const isEE = useEEActive();

  return (
    <>
      {isEE ? (
        <div className="card-grid-card">
          <GridCard
            id={props.id}
            dataSource={props.dataSource}
            image={model.image}
            mobileImage={model.mobileImage}
            cardHeadingTag={props.cardHeadingTag}
            title={model.title}
            subtitle={model.subtitle}
            link={model.link}
          />
        </div>
      ) : (
        <RoutableSitecoreLink className="card-grid-card" field={model.link} target={targetLinkdsk(model?.link, isDesktop)}>
          <GridCard
            id={props.id}
            dataSource={props.dataSource}
            image={model.image}
            mobileImage={model.mobileImage}
            cardHeadingTag={props.cardHeadingTag}
            title={model.title}
            subtitle={model.subtitle}
            link={model.link}
          />
        </RoutableSitecoreLink>
      )}
    </>
  );
};

export default GridCardWrapper;
